module.exports = __webpack_public_path__ + "static/img/1.d10fded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/4/1.png
// module id = Agpo
// module chunks = 0